module.exports = __webpack_public_path__ + "static/media/angry-regular.7723d41c.svg";